import type { ComponentType } from 'react'
import { forwardRef } from 'react'

import type { MouseProviderProps } from '../context/mouse'
import { MouseProvider } from '../context/mouse'
import { getComponentName } from './getComponentName'

export function withMouse<T>(
    Component: ComponentType<T>,
    settings?: MouseProviderProps
) {
    const WithMouse = forwardRef<any, T>((props, ref) => (
        <MouseProvider {...settings}>
            <Component {...props} ref={ref} />
        </MouseProvider>
    ))

    WithMouse.displayName = `WithMouse(${getComponentName(Component)})`
    return WithMouse
}
